import { createFileRoute } from "@tanstack/react-router";
import { RadixExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/radix/radix-examples",
)({
  component: RadixExamples,
});
